import React from "react"

export const PootsyMultiSelectCurrentFilter = ({ name, value, removeField }) => {
	return (
		<span className="pootsy-multiselect-current-filter" onClick={() => removeField(value)}>
			{name}
		</span>
	)
}
